import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SideMenu, SideMenuItem } from "../side-menu";
import { Badge } from "../badge";
import { styled } from "../theme";
export const SideMenuWithErrorCount = ({ items }) => (_jsx(SideMenu, { children: items.map(item => {
        return (_jsx(SideMenuItem, { children: ({ Link }) => (_jsx(Link, { to: item.path, disabled: item.disabled, style: {}, children: _jsxs(TitleAndBadge, { children: [item.title, item.errorCount > 0 && (_jsx(Badge, { style: {
                                position: "absolute",
                                top: "50%",
                                transform: "translateY(-50%)",
                                right: "0",
                            }, children: item.errorCount }))] }) })) }, item.path));
    }) }));
const TitleAndBadge = styled.span `
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;
